import { render } from "./MovieDetail.vue?vue&type=template&id=3b6257b7"
import script from "./MovieDetail.vue?vue&type=script&lang=js"
export * from "./MovieDetail.vue?vue&type=script&lang=js"

import "./MovieDetail.vue?vue&type=style&index=0&id=3b6257b7&lang=scss"
script.render = render

export default script